// extracted by mini-css-extract-plugin
module.exports = {"container":"SiteInfo_container__3dg82","siteTitle":"SiteInfo_siteTitle__1OBbz","siteAddress":"SiteInfo_siteAddress__3r9lD"};